import { combineReducers, createStore } from 'redux';
import { reducer as reducerForm } from 'redux-form'
import reducerUser from "./reducerUserInfo"
import reducerLang from "./reducerLang"
import reducerSearchResult from "./reducerSearchResult"

const allReducers = combineReducers({
    reducerLang,
    reducerUser,
    reducerSearchResult,
    form : reducerForm
});
// STORE
const store = createStore(allReducers);
export default store